/* eslint-disable @next/next/no-html-link-for-pages */
import { PartnerPageSMB } from "../../components/PartnerPageSMB"
import type { GetServerSidePropsContext } from "next"
import React from "react"

interface Props {
  businessClassificationId?: string
}
const BizeePartnerPage = ({ businessClassificationId }: Props) => {
  return (
    <PartnerPageSMB
      partner="Bizee"
      partnerLogoUrl="https://coverdash.s3.amazonaws.com/images/bizee-logo.png"
      partnerLogoClassName="max-h-7 ml-4"
      percentage={30}
      license="eaeb2a94-0207-404c-87b0-39570effbf2b"
      businessClassificationId={businessClassificationId}
      prefillCompanyType={false}
    />
  )
}

export default BizeePartnerPage

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const { businessClassificationId } = ctx.query
  console.log(ctx.query)

  return {
    props: {
      businessClassificationId: businessClassificationId
        ? decodeURIComponent(businessClassificationId as string)
        : null,
    },
  }
}
